import type { TransferStats } from '../lib/transfer/types';
import { formatBytes, formatEta, formatSpeed } from '../lib/util/format';

export function TransferProgress({ stats }: { stats: TransferStats | null }) {
  const percent = stats ? Math.min(100, Math.max(0, stats.percent)) : 0;
  return (
    <div className="space-y-3">
      <div className="h-3 w-full overflow-hidden rounded-full bg-ink-800">
        <div
          className="h-full rounded-full bg-gradient-to-r from-brand-500 to-brand-400 transition-[width] duration-300 ease-out"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={Math.round(percent)}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm sm:grid-cols-4">
        <Stat label="Progress" value={`${percent.toFixed(1)}%`} />
        <Stat
          label="Transferred"
          value={stats ? formatBytes(stats.bytesTransferred) : '0 B'}
          sub={stats ? `of ${formatBytes(stats.totalBytes)}` : undefined}
        />
        <Stat label="Speed" value={stats ? formatSpeed(stats.speedBytesPerSec) : '—'} />
        <Stat label="ETA" value={stats ? formatEta(stats.etaSeconds) : '—'} />
      </div>
    </div>
  );
}

function Stat({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="rounded-xl bg-ink-900/60 px-3 py-2 ring-1 ring-white/5">
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className="mt-0.5 font-semibold text-slate-100">{value}</div>
      {sub && <div className="text-xs text-slate-500">{sub}</div>}
    </div>
  );
}
